
function setButtonLabelKeepingImage(parentSelector, newText) {
  const parent = document.querySelector(parentSelector);
  if (!parent) return false;

  const btn = parent.querySelector("button");
  if (!btn) return false;

  // Keep image/svg, only update the text node
  const textNode = [...btn.childNodes].find(
    (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim().length
  );

  if (textNode) {
    textNode.textContent = ` ${newText}`;
  } else {
    // If there was no text node, append one after the image
    btn.append(document.createTextNode(` ${newText}`));
  }

  return true;
}

document.addEventListener("DOMContentLoaded", () => {
  // If it exists now:
  if (setButtonLabelKeepingImage("#paas3d-ball", "CUSTOMISE AND ADD TO CART")) return;

  // If it loads later:
  const obs = new MutationObserver(() => {
    if (setButtonLabelKeepingImage("#paas3d-ball", "CUSTOMISE AND ADD TO CART")) obs.disconnect();
  });
  obs.observe(document.body, { childList: true, subtree: true });
});
